import type { LifeguardPreLoginRequest } from "../../../../api/client/types/auth.types";
import { LifeguardPreLoginForm } from "../../components/LifeguardPreLoginForm/LifeguardPreLoginForm";
import { usePreLoginLifeguard } from "../../services/authService";

export const LifeguardPreLoginPage: React.FC = () => {
  const { mutate: preLoginLifeguard, isPending: isSubmitting } =
    usePreLoginLifeguard();

  const onPreLogin = (data: LifeguardPreLoginRequest) => {
    preLoginLifeguard(data);
  };

  return (
    <div className="flex items-center justify-center">
      <LifeguardPreLoginForm
        onPreLogin={onPreLogin}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};
